.select-field {
  width: 100%;
  max-width: 20rem;
  position: relative;
}

.select-label-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.select-label.is-sr-only {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.select-label .select-label-content {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  overflow: hidden;
}

.select-container {
  position: relative;
}

.select-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: border-color 0.2s;
}
.select-box.is-disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}
.select-box.is-open {
  background-color: var(--fdt-button-color-secondary-background-pressed);
  border-color: var(--fdt-button-color-secondary-foreground-pressed);
  transition: color 0.2s;
}

.select-dropdown {
  position: absolute;
  z-index: 10;
  margin-top: 0.25rem;
  background-color: white;
  border-radius: 0.375rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 15rem;
  overflow-y: auto;
  left: 0;
  top: 100%;
  transform: none;
  min-width: 100%;
}

.align-horizontal-left {
  left: 0;
  right: auto;
  transform: none;
}

.align-horizontal-center {
  left: 50%;
  transform: translateX(-50%);
  right: auto;
}

.align-horizontal-right {
  right: 0;
  left: auto;
  transform: none;
}

.align-vertical-top {
  top: 0;
  bottom: auto;
  transform: translateY(-100%);
}

.align-vertical-middle {
  top: 50%;
  transform: translateY(-50%);
}

.align-vertical-bottom {
  top: 100%;
  bottom: auto;
  transform: none;
}

.select-option {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #e1e8eb;
}
.select-option:hover, .select-option.is-selected {
  background-color: #f3f4f6;
}

.select-error-message {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #dc2626;
}

.select-description {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.select-icon {
  color: var(--fdt-core-color-primary-500);
  transition: color 0.2s;
}

.select-box.is-open .select-icon {
  color: var(--fdt-core-color-primary-800);
  transition: color 0.2s;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */